export default "__VITE_ASSET__5m4aQYW3__"